import { useState, useEffect } from "react";

const useWindowWidth = () => {
  const [width, setWidth] = useState(
    () => (typeof window !== "undefined" ? window.innerWidth : 0)
  );

  useEffect(() => {
    let frame = null;
    const handleResize = () => {
      if (frame) return;
      frame = requestAnimationFrame(() => {
        frame = null;
        setWidth(window.innerWidth);
      });
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
      if (frame) cancelAnimationFrame(frame);
    };
  }, []);

  return width;
};

export default useWindowWidth;
